// @libraries
import * as Yup from 'yup'

export const validationSchema = Yup.object().shape(
  {
    newPassword: Yup.string().when(['newPasswordRetype', 'password'], {
      is: (newPasswordRetype, password) => {
        return !!newPasswordRetype || !!password
      },
      then: Yup.string()
        .required('New Password is Required!')
        .min(7, 'Must be 7 characters or more')
        .matches(/^(?=.*\d).+$/, 'Password must contain at least one number'),
      otherwise: Yup.string(),
    }),
    newPasswordRetype: Yup.string().when(['newPassword', 'password'], {
      is: (newPassword, password) => {
        return !!newPassword || !!password
      },
      then: Yup.string()
        .required('Password retype is required!')
        .oneOf([Yup.ref('newPassword')], 'Password does not match'),
      otherwise: Yup.string(),
    }),
    password: Yup.string().when(['newPassword', 'newPasswordRetype'], {
      is: (newPassword, newPasswordRetype) => {
        return !!newPassword || !!newPasswordRetype
      },
      then: Yup.string().required('Current Password is required!'),
      otherwise: Yup.string(),
    }),
  },
  [
    ['newPasswordRetype', 'password'],
    ['newPassword', 'password'],
    ['newPassword', 'newPasswordRetype'],
  ],
)

// const newPassword = Yup.string()
//   .min(7, 'Must be 7 characters or more')
//   .matches(/^(?=.*\d).+$/, 'Password must contain at least one number')
//   .required('Password is required!')
//
// const newPasswordRetype = Yup.string()
//   .oneOf([Yup.ref('newPassword')], 'Password does not match')
//   .required('Password is required!')

// export const validationSchema = Yup.object().shape({
//   //primaryEmailAddress,
//   password,
//   newPassword,
//   newPasswordRetype,
// })
